import {Component} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {UiBackdropComponent} from 'freyr-ui';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, UiBackdropComponent],
  templateUrl: './app.component.html'
})
export class AppComponent {}
